import { GeneralModal } from '@framework/ui/elements/GeneralModal';
import { UserSurveyOperation } from './UserSurveyOperation';
import type { GroupId, UserId } from 'balus-common';
import { Modal } from '@framework/ui/elements';
import { Button } from '@framework/ui/atoms/Button';
import { UserSurveyForm } from './UserSurveyForm';
import { useUserSurveyForm } from './useUserSurveyForm';
import { useTranslation } from 'react-i18next';

type AnswerModalProps = {
  isOpen: boolean;
  onClose(): void;
  onAnswerCompleted(): void;
  groupId: string;
  userId: string;
  surveyId: string;
};

const UserSurveyAnswerModal: React.FC<AnswerModalProps> = ({
  isOpen,
  onClose,
  onAnswerCompleted,
  groupId,
  userId,
  surveyId,
}: AnswerModalProps) => {
  const { t } = useTranslation();
  const handleCloseModal = async () => {
    await UserSurveyOperation.cancel(userId);

    onClose();
  };

  return (
    <GeneralModal
      isOpen={isOpen}
      onClose={handleCloseModal}
      title={t('auth.survey.modal.title')}
      submitButton={<></>}
      cancelButton={<></>}
      shouldCloseOnOverlayClick={false}
    >
      <UserSurveyForm
        groupId={groupId}
        userId={userId}
        surveyId={surveyId}
        onAnswerCompleted={onAnswerCompleted}
        onCancel={handleCloseModal}
      />
    </GeneralModal>
  );
};

type ThanksModalProps = {
  isOpen: boolean;
  onClose(): void;
};

const UserSurveyThanksModal: React.FC<ThanksModalProps> = ({ isOpen, onClose }: ThanksModalProps) => {
  const { t } = useTranslation();
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="mx-8" style={{ height: '320px' }}>
        <div className={'p-3 text-xl'}>{t('auth.survey.modal.title')}</div>
        <div className="pt-8">{t('auth.survey.thanks.message')}</div>
        <div className={'flex justify-center pt-20'}>
          <div className={'pr-2'}>
            <Button color="secondary" onClick={onClose}>
              {t('common.action.close')}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

type Props = {
  currentUserId: UserId;
  groupId: GroupId;
};

export const UserSurveyModal: React.FC<Props> = ({ currentUserId, groupId }: Props) => {
  const { showSurveyForm, showThanks, surveyId, handleCloseModal, handleCloseThanksModal, handleAnswerCompleted } =
    useUserSurveyForm();

  return (
    <>
      <UserSurveyAnswerModal
        isOpen={showSurveyForm}
        groupId={groupId}
        userId={currentUserId}
        surveyId={surveyId}
        onClose={handleCloseModal}
        onAnswerCompleted={handleAnswerCompleted}
      />
      <UserSurveyThanksModal isOpen={showThanks} onClose={handleCloseThanksModal} />
    </>
  );
};
